var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnarchive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "unarchive-svg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    className: "svg unarchive",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, ".st0{fill-rule:evenodd;clip-rule:evenodd;}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20,0l1.8,1.8H28v3.5H3.2V1.8h6.2L11.2,0H20z M8.5,31.9c-2,0-3.5-1.6-3.5-3.5V7.1h21.3v21.3 c0,2-1.6,3.5-3.5,3.5H8.5z M8.5,19.5v-8.9h14.2v8.9l-7.1-7.1L8.5,19.5z M8.5,19.5v8.9h14.2v-8.9h-3.5v7.1H12v-7.1H8.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnarchive);
export default __webpack_public_path__ + "static/media/unarchive.97230ace3773f617758049393972d3ae.svg";
export { ForwardRef as ReactComponent };